export const COMMIT_HASH = 'e2814d82978505693d9f90c4051759ad8f3fae06';
